import { CTA_FIND_YOUR_FORMULA, CTA_FIND_YOUR_TREATMENT } from 'consts/copy';

export const getDefaultNavCtaText = (
  isCelebrityLaunchEnabled: boolean | undefined,
) => {
  if (isCelebrityLaunchEnabled === undefined) {
    return undefined;
  }

  return isCelebrityLaunchEnabled
    ? CTA_FIND_YOUR_FORMULA
    : CTA_FIND_YOUR_TREATMENT;
};
